module.exports = __webpack_public_path__ + "static/media/medietetic-logo.ab19fba5.svg";